<template>
  <div class="box">
    <headTotal ref="headTotal" @selectOptionP="selectOption" @setGameListP="setGameList" @setLastSearchTypeP="setLastSearchType"></headTotal>
    <div class="classList" >
      <div class="item" :key="item.id" v-for="item in classList" style="line-height:24px;text-align: left;margin-top: 15px;display: flex;align-items: flex-start;">
        <span>{{item.label}}</span>
        <div style="display: flex;flex: 1;flex-wrap: wrap;line-height:24px;">
            <span :style="{color:!selectInfo[item.id]?'#54d651 !important':'#555'}" style="cursor: pointer;color: #555;margin-left: 10px;" @click="all(item.id)">全部</span>
          <span :style="{color:selectInfo[item.id]==item1.id?'#047903':'#555'}" :key="item1.id" v-for="item1 in item.child" @click="selectOption(item.id,item1.id)" style="cursor: pointer;margin-left: 10px;">
            {{item1.label}}
            </span>
        </div>
      </div>
    </div>

    <div class="gameList" style="background-color: #fff;width:80%;margin:auto;display: flex; flex-wrap: wrap;">

        <div @click="selectGame(game)" class="game" v-for="game in gameList" :key="game.id" style="position: relative;cursor:pointer;width: 19%;margin: 20px 0.5%;text-align: left">
          <div class="gameImgBox" style="width:100%;height:150px;overflow: hidden;">
            <img :src="baseUrl+(game.imgs?game.imgs.split(',')[0]:'')" alt=""  class="gameImg">

          </div>

          <span class="gameName" style="text-align: left;">{{game.name}}</span>
          <div style="margin-top: 2px;display: flex;font-size: 12px;flex-wrap: wrap;">
            <el-tag size="mini" v-for="(tag,key) in game.tags" :key="tag.name" style="color:#fff;" :style="{backgroundColor:key==0?'rgb(241,42,20,0.7)':(key==1?'rgb(58,148,28,0.7)':'rgb(28,80,148,0.7)')}">
              {{tag.name}}
            </el-tag>
          </div>

        </div>
    </div>
    <div class="footer" style="background-color: #fff">
      <el-pagination background @current-change="pageChange" :page-size="20" :current-page="page" :total="total"  layout="prev, pager, next"></el-pagination>
    </div>
    <transition name="fade" mode="out-in" >
      <gameDetail :row="row" v-if="gameInfoShow" @setGameInfoShow="setGameInfoShow"></gameDetail>
    </transition>
    <transition name="fade" mode="out-in" >
      <jiaocheng :row="row" v-if="jiaochengShow" @setGameInfoShow="setJiaochengShow"></jiaocheng>
    </transition>
<!--    <div class="kf" >-->
<!--        客服QQ<br/>-->
<!--      1832111057-->
<!--    </div>-->
<!--    <div class="pop" v-if="popShow" style="color: #fff;text-align:center;display: flex;justify-content: center;align-items: center;white-space: normal;padding: 20px;position: fixed;left: calc(50% - 200px);top:170px;width:200px;height:200px;background-color: rgba(44, 62, 80,0.4);border-radius: 15px;">-->
<!--      本网站页面虽然简约<br/>-->
<!--      但内容全网最全<br/>-->
<!--      价格全网最低<br/>-->
<!--      主打一个实用性-->
<!--    </div>-->

  </div>
</template>
<script>
import header from "@/components/qt/header.vue";
import header1 from "@/components/qt/header1.vue";
import {getGameClassList, getGameCount, getGameList,getGameListByKeyWord} from "@/api/qt/common"
import gameDetail from "@/components/gameDetail/index.vue";
import jiaocheng from "@/components/gameDetail/indexJiaoCheng.vue";
import headTotal from "@/components/qt/headTotal.vue";
export default {
  components:{
    myHeader:header,
    gameDetail:gameDetail,
    jiaocheng:jiaocheng,
    header1:header1,
    headTotal:headTotal,
  },
  props:['cid'],
  data(){
    return {
      classList:[],
      selectInfo:{},
      gameList:[],
      baseUrl:"",
      page:1,
      lastSearchType:"",
      row:{},
      gameInfoShow:false,
      jiaochengShow:false,
      total:0,
      popShow:true,
      countData:{}
    };
  },
  created() {
    this.$nextTick(() => {
      if(localStorage.getItem('cid')){
        this.selectOption(2,localStorage.getItem('cid'))
      }
      console.log("keyword",localStorage.getItem('keyword'))
      if(localStorage.getItem('keyword')){
        this.$refs.headTotal.$refs.header.search=localStorage.getItem('keyword')
        getGameListByKeyWord(localStorage.getItem('keyword'),1).then((res)=>{
          let data=res.data.data.data

          this.setGameList(data);
        })
      }else{
         this.init();
      }

      // this.$refs.header1.setSelectId(this.cid)

    })
    this.getClassList();
    this.baseUrl=this.$baseUrl;



    // setTimeout(()=>{
    //   this.popShow=false;
    // },5000)
  },
  methods:{

    init(){
      let loading=this.$loading({
        mask:true,
      })
      let optionIdArr=this.getOptionIds(this.selectInfo).join(",");
      getGameList(optionIdArr,this.page).then(res=>{
        let data=res.data.data.data;
        this.gameList=data;
        this.total=res.data.data.total;
        loading.close()
      })
    },
    all(id){
      let loading=this.$loading({
        mask:true,
      })
      this.selectInfo[id]='';
      let optionIdArr=this.getOptionIds(this.selectInfo).join(",");
      getGameList(optionIdArr,this.page).then(res=>{
        let data=res.data.data.data;
        this.gameList=data;
        this.total=res.data.data.total;
        loading.close()
      })
    },
    setJiaochengShow(show){
      this.jiaochengShow=show;
    },
    setGameInfoShow(show){
      this.gameInfoShow=show;
    },
    selectGame(row){

      let str=row.id+'-'+row.cls_ids
      window.open('/#detail?info='+ str,"_blank");
    },
    // selectGame(game){
    //   this.row=game;
    //
    //   if(game.cls_ids.includes(',41,')){
    //     this.jiaochengShow=true;
    //   }else{
    //     this.gameInfoShow=true;
    //   }
    //
    // },
    setLastSearchType(type){
      this.lastSearchType = type;
    },
    pageChange(value){
      this.page=value;

      if(this.lastSearchType=="option" || this.lastSearchType==""){
        let loading=this.$loading({
          mask: true,
        })
        let optionIdArr=this.getOptionIds(this.selectInfo).join(",");
        getGameList(optionIdArr,this.page).then(res=>{
          let data=res.data.data.data;
          this.gameList=data;
          this.total=res.data.data.total;
          loading.close()
        })
      }else{
        this.$refs.header.searchEvent(null,this.page)
      }
    },
    setGameList(list){
      this.gameList=list;
    },
    getOptionIds(selectInfo){
      let optionIdArr=[];
      for(let key in selectInfo){
        if(selectInfo[key]){
          optionIdArr.push(selectInfo[key])
        }
      }
      return optionIdArr
    },
    selectOption(id,optionId){

      this.lastSearchType='option';
      let loading=this.$loading({
        mask: true,
      })
      this.$set(this.selectInfo,id,optionId);
      let optionIdArr=this.getOptionIds(this.selectInfo).join(",");
      this.page=1;
      getGameList(optionIdArr,this.page).then(res=>{
        let data=res.data.data.data;
        this.gameList=data;
        this.total=res.data.data.total;
        loading.close()
      })
    },

    getClassList(){
      getGameClassList().then((res)=>{
        console.log(res.data,"类型列表")
        this.classList = res.data.data;

        let data={};
        for(let i=0;i<this.classList.length;i++){
          let id=this.classList[i].id;
          let label=this.classList[i].name;
          data[id]={
            id:id,
            label:label,
            child:[]
          }
          for(let item of this.classList[i].with_option){
            data[id].child.push({
              id:item['id'],
              pid:item['c_id'],
              label:item['name']
            })
          }
        }
        console.log(data,"数据")
        this.classList=data;
      })
    }
  }
}
</script>
<style >
    .gameName{
      display: block;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden !important;
      font-size: 12px;
      line-height: 18px;
      margin-top: 3px;
    }
    .kf{

      border-radius: 10px;
      position: fixed;
      right:0px;
      bottom:calc(50vh - 20px);
      text-align: center;
      color: #fff;
      background-color: #2c3e50;
      padding: 9px 5px;
      display: inline-block;
    }
    .classList{
      width: 80%;
      margin: 15px auto 0px auto;
    }
    .box{
      width:90%;
      margin: auto;
      min-width: 1500px;
      background-color: #fff;
      min-height: 100vh;
      padding-bottom: 30px;
      position: relative;
    }

    .fade-enter{
      scale: 0;
    }
    .fade-enter-active{
      transition: scale 0.3s;
    }
    .fade-leave-to{
      scale: 0;
    }
    .fade-leave-active{
      transition: scale 0.3s;
    }
    .gameImg{
      width:100%;
      display: block;
      height:100%;
      border-radius: 4px;
      object-fit: cover;
    }
    .gameImg:hover{


      animation: scaleAni 0.5s forwards;
    }
    @keyframes scaleAni {
      0% {
        scale: 1;
      }
      100% {
        scale: 1.1;
      }
    }
</style>
